import { createNovoAccount, getCurrentMerchant, getFilteredMerchants } from '../api/MerchantApi';
import useBaseQuery from '../hooks/useBaseQuery';
import {
  AdminFilters,
  IBaseQueryOptions,
  ICreateNovoAccountResponse,
  IMerchantDetailsResponse,
} from '../types';
import IQueryKeys from '../types/IQueryKeys';

export const useCurrentMerchant = (options?: IBaseQueryOptions<IMerchantDetailsResponse>) => {
  return useBaseQuery([IQueryKeys.merchantInfoKey], () => getCurrentMerchant(), { ...options });
};

export const useNovoAccountUrl = (options?: IBaseQueryOptions<ICreateNovoAccountResponse>) => {
  return useBaseQuery([IQueryKeys.createNovoAccount], () => createNovoAccount(), { ...options });
};

export const useFilteredMerchants = (filters: AdminFilters) => {
  return useBaseQuery([IQueryKeys.filteredMerchantsKey, filters], () =>
    getFilteredMerchants(filters),
  );
};
